document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('#modal-password-reset');
  const form = document.querySelector('#request-password-reset-form');
  const emailError = document.querySelector('#emailError');
  const header = document.querySelector('.password-reset-header');
  const emailInput = document.querySelector('.reset-password-email-input');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      let formData = new FormData(this);

      fetch('/reset/heslo', {
        method: 'POST',
        body: formData,
      })
        .then(function (response) {
          if (response.ok) {
            return response.json();
          } else {
            return response.json().then((json) => Promise.reject(json));
          }
        })
        .then(function (jsonResponse) {
          header.innerText = jsonResponse.message;
          form.style.display = 'none';
          setTimeout(function () {
            modal.classList.remove('is-open');
          }, 3000);
        })
        .catch(function (error) {
          emailError.textContent = error.message;
          emailError.style.display = 'block';
        });
    });

    let observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'class') {
          let oldClass = mutation.oldValue; // the class list before mutation
          let newClass = modal.className; // the current class list

          if (oldClass.includes('is-open') && !newClass.includes('is-open')) {
            emailError.style.display = 'none';
            header.innerText = 'Zapomenuté heslo';
            form.style.display = 'block';
            emailInput.value = '';
          }
        }
      });
    });

    let config = { attributes: true, attributeOldValue: true };

    observer.observe(modal, config);
  }
});
